import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { spacing8 } from "@churchofjesuschrist/eden-style-constants";
const Li = styled.li.withConfig({
  componentId: "sc-1axifbm-0"
})(["&:not(:last-child){margin-block-end:", ";}"], spacing8);

const Item = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Li, props, children);
};

Item.propTypes = {
  /** Item contents */
  children: PropTypes.node.isRequired
};
export default Item;